import React, { useState, Component } from 'react';
import { Container } from '../components/ui/Container';
import { Button } from '../components/ui/Button';
import { Input } from '../components/ui/Input';
import { Shield, CheckCircle } from 'lucide-react';
export function SecurityPolicyPage() {
  const [formData, setFormData] = useState({
    name: '',
    role: '',
    company: '',
    email: ''
  });
  const [isSubmitted, setIsSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const subject = encodeURIComponent('Flowsense Information Security Policy request');
    const body = encodeURIComponent(`Information Security Policy Request\n\n` + `Name: ${formData.name}\n` + `Role: ${formData.role}\n` + `Company: ${formData.company}\n` + `Email: ${formData.email}\n\n` + `Please send the Flowsense Information Security Policy document to the email address provided above.`);
    window.location.href = `mailto:support@useflowsense.com?subject=${subject}&body=${body}`;
    setIsSubmitted(true);
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  return <div className="bg-white py-20 lg:py-28" data-id="element-2156">
      <Container size="md" data-id="element-2157">
        <div className="text-center mb-12" data-id="element-2158">
          <div className="inline-flex items-center justify-center p-3 bg-indigo-100 rounded-xl mb-6" data-id="element-2159">
            <Shield className="h-8 w-8 text-indigo-600" data-id="element-2160" />
          </div>
          <h1 className="text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl mb-4" data-id="element-2161">
            Information Security Policy
          </h1>
          <p className="text-xl text-gray-600 mb-2" data-id="element-2162">
            Acciom Limited - Flowsense Platform
          </p>
          <p className="text-sm text-gray-500" data-id="element-2163">
            Last updated: December 15, 2024
          </p>
        </div>

        {!isSubmitted ? <div className="max-w-2xl mx-auto" data-id="element-2164">
            <div className="bg-indigo-50 border-l-4 border-indigo-500 p-6 mb-8" data-id="element-2165">
              <p className="text-sm text-indigo-900 font-semibold mb-2" data-id="element-2166">
                REQUEST ACCESS TO OUR SECURITY POLICY
              </p>
              <p className="text-sm text-indigo-800" data-id="element-2167">
                Our comprehensive Information Security Policy is available upon
                request. Please complete the form below and we'll send you the
                full document via email.
              </p>
            </div>

            <div className="bg-white border border-gray-200 rounded-lg p-8 shadow-sm" data-id="element-2168">
              <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-2169">
                Request Policy Document
              </h2>

              <form onSubmit={handleSubmit} className="space-y-6" data-id="element-2170">
                <div data-id="element-2171">
                  <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2172">
                    Full Name *
                  </label>
                  <Input id="name" name="name" type="text" required value={formData.name} onChange={handleChange} placeholder="John Smith" className="w-full" data-id="element-2173" />
                </div>

                <div data-id="element-2174">
                  <label htmlFor="role" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2175">
                    Role / Title *
                  </label>
                  <Input id="role" name="role" type="text" required value={formData.role} onChange={handleChange} placeholder="Chief Technology Officer" className="w-full" data-id="element-2176" />
                </div>

                <div data-id="element-2177">
                  <label htmlFor="company" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2178">
                    Company Name *
                  </label>
                  <Input id="company" name="company" type="text" required value={formData.company} onChange={handleChange} placeholder="Acme Corporation" className="w-full" data-id="element-2179" />
                </div>

                <div data-id="element-2180">
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2181">
                    Email Address *
                  </label>
                  <Input id="email" name="email" type="email" required value={formData.email} onChange={handleChange} placeholder="john.smith@acme.com" className="w-full" data-id="element-2182" />
                </div>

                <div className="bg-gray-50 p-4 rounded-lg" data-id="element-2183">
                  <p className="text-sm text-gray-600" data-id="element-2184">
                    By submitting this form, you agree that Acciom Limited may
                    contact you regarding your request. We will send the
                    Information Security Policy document to the email address
                    provided above.
                  </p>
                </div>

                <Button type="submit" size="lg" className="w-full" data-id="element-2185">
                  Request Security Policy
                </Button>
              </form>
            </div>

            <div className="mt-8 bg-gray-50 p-6 rounded-lg" data-id="element-2186">
              <h3 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-2187">
                What's Included in Our Security Policy?
              </h3>
              <ul className="space-y-2 text-sm text-gray-700" data-id="element-2188">
                <li className="flex items-start" data-id="element-2189">
                  <CheckCircle className="h-5 w-5 text-green-600 mr-2 flex-shrink-0 mt-0.5" data-id="element-2190" />
                  <span data-id="element-2191">
                    Comprehensive governance and organizational structure
                  </span>
                </li>
                <li className="flex items-start" data-id="element-2192">
                  <CheckCircle className="h-5 w-5 text-green-600 mr-2 flex-shrink-0 mt-0.5" data-id="element-2193" />
                  <span data-id="element-2194">Data classification and handling procedures</span>
                </li>
                <li className="flex items-start" data-id="element-2195">
                  <CheckCircle className="h-5 w-5 text-green-600 mr-2 flex-shrink-0 mt-0.5" data-id="element-2196" />
                  <span data-id="element-2197">Access control and authentication requirements</span>
                </li>
                <li className="flex items-start" data-id="element-2198">
                  <CheckCircle className="h-5 w-5 text-green-600 mr-2 flex-shrink-0 mt-0.5" data-id="element-2199" />
                  <span data-id="element-2200">Network and infrastructure security measures</span>
                </li>
                <li className="flex items-start" data-id="element-2201">
                  <CheckCircle className="h-5 w-5 text-green-600 mr-2 flex-shrink-0 mt-0.5" data-id="element-2202" />
                  <span data-id="element-2203">
                    Application security and secure development lifecycle
                  </span>
                </li>
                <li className="flex items-start" data-id="element-2204">
                  <CheckCircle className="h-5 w-5 text-green-600 mr-2 flex-shrink-0 mt-0.5" data-id="element-2205" />
                  <span data-id="element-2206">
                    Data protection, privacy, and GDPR/CCPA compliance
                  </span>
                </li>
                <li className="flex items-start" data-id="element-2207">
                  <CheckCircle className="h-5 w-5 text-green-600 mr-2 flex-shrink-0 mt-0.5" data-id="element-2208" />
                  <span data-id="element-2209">Encryption standards and cryptography practices</span>
                </li>
                <li className="flex items-start" data-id="element-2210">
                  <CheckCircle className="h-5 w-5 text-green-600 mr-2 flex-shrink-0 mt-0.5" data-id="element-2211" />
                  <span data-id="element-2212">Backup and disaster recovery procedures</span>
                </li>
                <li className="flex items-start" data-id="element-2213">
                  <CheckCircle className="h-5 w-5 text-green-600 mr-2 flex-shrink-0 mt-0.5" data-id="element-2214" />
                  <span data-id="element-2215">
                    Security monitoring and incident response protocols
                  </span>
                </li>
                <li className="flex items-start" data-id="element-2216">
                  <CheckCircle className="h-5 w-5 text-green-600 mr-2 flex-shrink-0 mt-0.5" data-id="element-2217" />
                  <span data-id="element-2218">Third-party risk management and vendor assessment</span>
                </li>
                <li className="flex items-start" data-id="element-2219">
                  <CheckCircle className="h-5 w-5 text-green-600 mr-2 flex-shrink-0 mt-0.5" data-id="element-2220" />
                  <span data-id="element-2221">
                    Compliance framework (SOC 2, ISO 27001, GDPR, CCPA)
                  </span>
                </li>
              </ul>
            </div>

            <div className="mt-8 text-center" data-id="element-2222">
              <p className="text-sm text-gray-600 mb-4" data-id="element-2223">
                Have questions about our security practices?
              </p>
              <a href="mailto:support@useflowsense.com" className="text-indigo-600 hover:text-indigo-700 font-medium" data-id="element-2224">
                Contact our Security Team →
              </a>
            </div>
          </div> : <div className="max-w-2xl mx-auto text-center" data-id="element-2225">
            <div className="bg-green-50 border border-green-200 rounded-lg p-8" data-id="element-2226">
              <div className="inline-flex items-center justify-center p-3 bg-green-100 rounded-full mb-6" data-id="element-2227">
                <CheckCircle className="h-12 w-12 text-green-600" data-id="element-2228" />
              </div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-2229">
                Request Submitted Successfully
              </h2>
              <p className="text-gray-700 mb-6" data-id="element-2230">
                Your email client should have opened with a pre-filled message
                to our Security Team. If it didn't open automatically, please
                try from your mobile device.
              </p>
              <p className="text-sm text-gray-600 mb-6" data-id="element-2231">
                We'll review your request and send the Information Security
                Policy document to <strong data-id="element-2232">{formData.email}</strong> within 1-2
                business days.
              </p>
              <Button onClick={() => setIsSubmitted(false)} variant="outline" data-id="element-2233">
                Submit Another Request
              </Button>
            </div>
          </div>}
      </Container>
    </div>;
}